<template>
  <WorkBaseTabs
    v-bind="$props"
    content-class="w-tabs__content--table"
  />
</template>

<script>
import WorkBaseTabs from '@/components/base_components/tabs/WorkBaseTabs';

/**
 * @component WorkTabsTableContent
 * @description Tab component specifically for tabular content. Inherits all props
 * from `WorkBaseTabs` and uses a table-optimized layout.
 *
 * @prop {Boolean} [grow=true] - Stretch tabs to full width.
 * @prop {Number} [value=0] - Index of the active tab (v-model).
 *
 * @emits {Number} input - Emitted when a different tab is selected.
 */
export default {
  name: 'WorkTabsTableContent',
  components: { WorkBaseTabs },
  props: {
    ...WorkBaseTabs.props,
    grow: { type: Boolean, default: true },
    value: { type: Number, default: 0 }
  },
};
</script>

<style lang='scss'>
.w-tabs__content--table {
  padding-top: 0 !important;
}
</style>
